/**
 * Single source of truth for content that is not derived from project or
 * writing data. Values here are referenced by the spec sheet layout.
 */

export const siteConfig = {
  /** Sheet identifier shown in the header, left cell. */
  sheetNumber: 'CR—001',
  name: 'Colin Rodrigues',
  shortName: 'C. Rodrigues',
  initials: 'C.R.',
  location: 'Berlin, DE',
  shortLocation: 'Berlin',

  /**
   * Domain address. Forwarding is configured at the registrar (Porkbun);
   * until that is switched on, mail to this address will not arrive.
   */
  email: 'mail@colinrodrigues.com',

  /** Booking link used by the §01 Contact button. */
  bookingUrl: 'https://calendar.app.google/E1KMH1Vmq3MgwMah7',

  /** §01 spec list, final row. Factual rather than a call to action. */
  availability: 'Berlin · Remote · Open to conversations',

  summary:
    'Electrical engineer by training, commercial operator by trade. I build small, well-made products and document how they come together, from the first spec to the last commit.',

  /** H1, one word per line. */
  headline: ['Operator.', 'Engineer.', 'Explorer.'],

  /** §01 spec list rows, in order. The last row is the availability value. */
  specList: [
    { label: 'Training', value: 'B.Eng Electrical Engineering' },
    { label: 'Business', value: 'MBA, INSEAD' },
    {
      label: 'Previously',
      value: 'Sellpy, Wolt, Wayfair, Doordash, Amazon, OHB Systems, Honeywell',
    },
    { label: 'Based', value: 'Berlin' },
  ],

  /** Number of projects listed in the §02 parts table on the homepage. */
  homepageProjectCount: 4,
} as const

/** Header revision string, generated from the build date. */
export function revision(date: Date = new Date()): string {
  const month = String(date.getMonth() + 1).padStart(2, '0')
  return `Rev. ${date.getFullYear()}.${month}`
}
